import { metricKeys } from '@pulse/metrics';
import { isNumber } from 'lodash';

export const dimensionTraceId = 'trace_id';
export const dimensionsShouldFilteroutUnknown = [dimensionTraceId];

export const networkMetrics = [
  metricKeys.AverageRequestDuration,
  metricKeys.AverageRequestCount,
  metricKeys.AppUniqueDevices,
];
/** metrics need to calculate sample secondary filter percentage */
export const metricsToCallSSFPct = [metricKeys.AverageRequestCount, metricKeys.AppUniqueDevices];

export const getSSFPctMetric = (metric) => `${metric}::ssfPct`;
export const getPctMetric = (metric) => `${metric}::pct`;

export function calcPercentage(total?: number, value?: number) {
  if (!isNumber(total) || !isNumber(value)) {
    return 'NA';
  }
  const pct = (value / total) * 100;
  return Number.isNaN(pct) || !Number.isFinite(pct) ? 'NA' : pct;
}

export enum ETableMode {
  drilldown = 'drilldown',
  filter = 'filter',
  compare = 'compare',
  showDrawer = 'showDrawer',
}

export const rcaMetrics = [
  metricKeys.AverageRequestCount,
  metricKeys.AppUniqueDevices,
  metricKeys.AverageRequestDuration,
];

export const networkRequestUrlDimensions = {
  host: 'network_request_url_host',
  path: 'network_request_url_path',
  query: 'network_request_url_query',
};

export const compositeNetworkRequestUrlDimenison = 'network_api_calls';

export const hintColorMap = {
  Outlier: '#0046FF',
  'Worse in Impacted': '#08979C',
};
